module.exports = __webpack_public_path__ + "assets/h1.6f56abff.svg";